import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateChildFn,
  CanActivateFn,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthService } from '../services';

export const canActivate: CanActivateFn = async (): Promise<boolean> => {
  const authService = inject(AuthService);
  const isAuth = await authService.isLoggedIn();
  if (!isAuth) authService.login();
  return isAuth;
};

export const canActivateChild: CanActivateChildFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => canActivate(route, state);
